module.exports = __webpack_public_path__ + "img/30JahrEhrung.jpg";